import { API_CACHE_TTL, fetchCachedGetApi } from "./apiCache";
import { gatedArtistSlug } from "./artistGate";
import { getRouteArtistSlug, isReservedRootPath } from "./routePaths";

const LIST_PAGES = new Set(["songs", "albums"]);

export function listRouteArtist(pathname: string): string | null {
  const parts = String(pathname || "").split("/").filter(Boolean);
  const listRoot = parts.length === 1 && LIST_PAGES.has(parts[0].toLowerCase());
  const artistList = parts.length === 2 && !isReservedRootPath(parts[0]) && LIST_PAGES.has(parts[1].toLowerCase());
  if (!listRoot && !artistList) return null;
  if (gatedArtistSlug(pathname)) return null;
  return getRouteArtistSlug(parts);
}

export function prefetchListRouteData(pathname: string): string | null {
  const artist = listRouteArtist(pathname);
  if (!artist) return null;
  fetchCachedGetApi<{ artistData?: unknown }>("/.netlify/functions/SpotifyGetArtist", { artist }, {
    ttlMs: API_CACHE_TTL.SIX_HOURS,
    shouldCache: (data) => Boolean(data?.artistData),
  }).catch(() => undefined);
  fetchCachedGetApi<{ albums?: unknown[] }>("/.netlify/functions/SpotifyGetArtistAlbums", { artist }, {
    ttlMs: API_CACHE_TTL.SIX_HOURS,
    shouldCache: (data) => Array.isArray(data?.albums),
  }).catch(() => undefined);
  return artist;
}
